import styles from './GradientOverlay.module.scss';
import { FC } from 'react';

const GradientOverlay: FC = () => {
  return <div className={styles.overlay} />;
};

export { GradientOverlay };
